import React from 'react';
import { Link, navigate } from '@reach/router';
import Button from '@material-ui/core/Button';
import {
  emailValidator,
  minLength,
  passwordConfirm,
  required
} from '../../../validators/form-validators';
import classes from './registration.module.scss';
import REGISTER from './registration-mutation';
import Form, { IState } from '../../form/form';

const Registration = () => {
  const state: IState = {
    email: {
      label: 'Електронна адреса',
      config: {
        type: 'email',
        placeholder: 'Введіть свою електронну адресу'
      },
      value: '',
      validators: [required, emailValidator],
      errorMessage: ''
    },
    firstName: {
      label: `Ім'я`,
      config: {
        type: 'text',
        name: 'firstname',
        placeholder: `Введіть своє ім'я`
      },
      value: '',
      validators: [required],
      errorMessage: ''
    },
    lastName: {
      label: 'Прізвище',
      config: {
        type: 'text',
        name: 'lastname',
        placeholder: 'Введіть своє прізвище'
      },
      value: '',
      validators: [required],
      errorMessage: ''
    },
    password: {
      label: 'Пароль',
      config: {
        type: 'password',
        placeholder: 'Придумайте пароль (мінімум 6 знаків)'
      },
      value: '',
      validators: [required, minLength(6)],
      errorMessage: ''
    },
    confirmPassword: {
      label: 'Підтвердження пароля',
      config: {
        type: 'password',
        placeholder: 'Повторіть пароль'
      },
      value: '',
      validators: [required, minLength(6), passwordConfirm],
      dependency: 'password',
      errorMessage: ''
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div>
          <span className={classes.enterPersonalRoomText}>Зареєструватися</span>
          <span className={classes.enterDetailsText}>
            Введіть нижче свої дані
          </span>
        </div>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <Button
            data-e2e-id={'login-button'}
            variant="outlined"
            style={{ textTransform: 'capitalize' }}
          >
            Увійти
          </Button>
        </Link>
      </div>
      <Form
        state={state}
        mutation={REGISTER}
        submitOptions={{
          keys: ['email', 'password', 'firstName', 'lastName'],
          label: 'Зареєструватися',
          id: 'register',
          redirectTo: formState =>
            navigate(`/verify-email/${formState.email.value}`)
        }}
      />
      <p className={classes.rules}>
        Натискаючи "Зареєтруватися" я погоджуюся з "<a href="#">Правилами</a>"
        участі у програмі.
      </p>
    </div>
  );
};

export default Registration;
